module.exports = __webpack_public_path__ + "img/category_41.264158fd.png";